export enum PasswordRuleTypes {
  MIN_LENGTH = 'MIN_LENGTH',
  MAX_LENGTH = 'MAX_LENGTH',
  LOWERCASE_CHARS = 'LOWERCASE_CHARS',
  UPPERCASE_CHARS = 'UPPERCASE_CHARS',
  SPECIAL_CHARS = 'SPECIAL_CHARS',
  DIGITS_CHARS = 'DIGITS_CHARS',
  NOT_EMAIL = 'NOT_EMAIL',
  NOT_SAME_PASSWORD = 'NOT_SAME_PASSWORD',
  NO_SPACES = 'NO_SPACES',
}

export type PasswordRule = {
  ruleType:
    | PasswordRuleTypes.UPPERCASE_CHARS
    | PasswordRuleTypes.LOWERCASE_CHARS
    | PasswordRuleTypes.SPECIAL_CHARS
    | PasswordRuleTypes.DIGITS_CHARS
    | PasswordRuleTypes.MIN_LENGTH
    | PasswordRuleTypes.MAX_LENGTH
    | PasswordRuleTypes.NOT_EMAIL
    | PasswordRuleTypes.NO_SPACES;
  value?: string;
};

export enum UsernameRuleTypes {
  NUMBER_OF_CHARACTERS = 'NUMBER_OF_CHARACTERS',
  NUMBER_OF_NUMERIC_CHARACTERS = 'NUMBER_OF_NUMERIC_CHARACTERS',
  NUMBER_OF_SPECIAL_CHARACTERS = 'NUMBER_OF_SPECIAL_CHARACTERS',
  USERNAME_REGULAR_EXPRESSION = 'USERNAME_REGULAR_EXPRESSION',
}

export type UsernameRule = {
  ruleType:
    | UsernameRuleTypes.NUMBER_OF_CHARACTERS
    | UsernameRuleTypes.NUMBER_OF_NUMERIC_CHARACTERS
    | UsernameRuleTypes.NUMBER_OF_SPECIAL_CHARACTERS
    | UsernameRuleTypes.USERNAME_REGULAR_EXPRESSION;
  value: string;
};

export type AuthenticationMethod = 'SCA' | 'OTP';
